var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { RowsComponent } from '../list/rows.component';
import { MemberSearchService } from './member_search.service';
var MemberSearchRowsComponent = /** @class */ (function (_super) {
    __extends(MemberSearchRowsComponent, _super);
    function MemberSearchRowsComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        return _this;
    }
    MemberSearchRowsComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.pager.count_per_page = this.service.getCurrentMemberQuery().limit;
    };
    MemberSearchRowsComponent.prototype.onEvent = function (e1, e2, rec) {
        if (e2 === 'rows') {
            this.action.setRec(this.service.getMemberQuery({ limit: rec, page: 1 }));
            this.action.firstAction(e2);
        }
    };
    MemberSearchRowsComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'membersearch-rows',
                    template: "<p class=\"-note\" id=\"{{ componentName }}\">\n  {{ (msg | async)['ListComponent.label.rows'] }}\n  <column-select [col]=\"{required: true, disabled: !clickable, params: {options: options}}\" [val]=\"pager.count_per_page\" [msg]=\"(msg | async)\" (changeVal)=\"onEvent('', 'rows', $event.val)\"></column-select>\n</p>\n"
                }] }
    ];
    /** @nocollapse */
    MemberSearchRowsComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: MemberSearchService }
    ]; };
    return MemberSearchRowsComponent;
}(RowsComponent));
export { MemberSearchRowsComponent };
//# sourceMappingURL=rows.component.js.map